module.exports = __webpack_public_path__ + "img/oh-du-fröhliche.badf5bac.jpeg";